import React from "react";
import { HiOutlineCube } from "react-icons/hi2";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import PrimaryButton from "../../../components/buttons/PrimaryButton";

const Wrapper = styled.div`
  margin: 100px 0;
`;

const Container = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
`;

const Description = styled.p`
  max-width: 300px;
  text-align: center;
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
`;

function OrdersSection() {
  return (
    <Wrapper>
      <Container>
        <Header>
          <HiOutlineCube size={40} />
          <Description>You currently have no orders</Description>
        </Header>

        <PrimaryButton title={"Continue Shopping"} width="min(100%, 20%)" />
      </Container>
    </Wrapper>
  );
}

export default OrdersSection;
